import {observable} from 'mobx'

export default class ProfileDocument {
    /** @type {Boolean} */
    @observable document_exists = false
    /** @type {Boolean} */
    @observable is_expired = true
    @observable document_page_url = ''
    @observable document_download_url = ''
    @observable updated_time = null
    @observable updated_humandatetime = ''

    constructor(file) {
        if (file) {
            this.document_exists = file.document_exists
            this.is_expired = file.is_expired
            this.document_page_url = file.document_page_url
            this.document_download_url = file.document_download_url
            this.updated_time = file.updated_time
            this.updated_humandatetime = file.updated_humandatetime
        }
    }
}